import { Experiment } from '@cian/experiments/ab';
import classNames from 'classnames';
import * as React from 'react';

import { ETabType } from '../../types/filters';
import { PERS_SAVED_SEARCH_FAVORITES_MERGE_EXPERIMENT } from '../../constants/experiments';

import * as styles from './styles.css';

interface IEntityTypeToggle {
  type: ETabType | null;
  showSaveSearchEntity: boolean;
  showComparisonEntity: boolean;
  clickSavedSearch(): void;
  onAdvertisementsClick(): void;
  onJKClick(): void;
  onSavedSearchClick(): void;
  onComparisonClick(): void;
}

export const EntityTypeToggle: React.FC<IEntityTypeToggle> = ({
  type,
  showSaveSearchEntity,
  showComparisonEntity,
  clickSavedSearch,
  onAdvertisementsClick,
  onJKClick,
  onSavedSearchClick,
  onComparisonClick,
}) => {
  return (
    <div className={styles['container']} data-name="EntityTypeToggle">
      <div className={styles['filters']}>
        <div className={styles['row']}>
          <ul className={styles['favorites-type']}>
            <Experiment name={PERS_SAVED_SEARCH_FAVORITES_MERGE_EXPERIMENT} group="B">
              <li
                onClick={onAdvertisementsClick}
                className={classNames(
                  styles['favorites-type-item'],
                  type !== ETabType.JK &&
                    type !== ETabType.SavedSearches &&
                    type !== ETabType.Comparison &&
                    styles['favorites-type-item--active'],
                )}
              >
                Квартиры
              </li>
            </Experiment>
            <Experiment name={PERS_SAVED_SEARCH_FAVORITES_MERGE_EXPERIMENT} group="A" default>
              <li
                onClick={onAdvertisementsClick}
                className={classNames(
                  styles['favorites-type-item'],
                  type !== ETabType.JK && type !== ETabType.Comparison && styles['favorites-type-item--active'],
                )}
              >
                Квартиры
              </li>
            </Experiment>
            <li
              onClick={onJKClick}
              className={classNames(
                styles['favorites-type-item'],
                type === ETabType.JK && styles['favorites-type-item--active'],
              )}
            >
              ЖК
            </li>
            <Experiment name={PERS_SAVED_SEARCH_FAVORITES_MERGE_EXPERIMENT} group="B">
              <li
                onClick={onSavedSearchClick}
                className={classNames(
                  styles['favorites-type-item'],
                  type === ETabType.SavedSearches && styles['favorites-type-item--active'],
                )}
              >
                Поиски
              </li>
            </Experiment>
            <Experiment name={PERS_SAVED_SEARCH_FAVORITES_MERGE_EXPERIMENT} group="A" default>
              {showSaveSearchEntity && (
                <li onClick={clickSavedSearch} className={styles['favorites-type-item']} role="link">
                  Поиски
                </li>
              )}
            </Experiment>
            {showComparisonEntity && (
              <li
                onClick={onComparisonClick}
                className={classNames(
                  styles['favorites-type-item'],
                  type === ETabType.Comparison && styles['favorites-type-item--active'],
                )}
                data-name="ComparisonTab"
              >
                Сравнение
              </li>
            )}
          </ul>
        </div>
      </div>
    </div>
  );
};
